module.exports = __webpack_public_path__ + "static/media/paintparty.0189b82c.jpg";